import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {LoaderService} from '@shared/service/loader.service';
import {UploadFileService} from '@shared/service/upload-file.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {AddAttachedFileUtilitiesModel} from '@shared/utilities/add-attached-file-utilities.model';
import {DigitalSignAttachmentModel} from '@shared/components/core-sign/models/digital-sign-attachment.model';
import {MatDialog} from '@angular/material/dialog';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import {CommonMessageCode, MessageComponentType, MessageType} from '@shared/service/message-manager/message.model';
import {TranslateContext} from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-core-sign-attachment',
	templateUrl: './core-sign-attachment.component.html',
	styleUrls: ['./core-sign-attachment.component.scss']
})
export class CoreSignAttachmentComponent {

	@Input() canRemoveAttach: boolean = true;
	@Input() attachments: DigitalSignAttachmentModel[] = [];
	@Output() onRemoveFile: EventEmitter<any> = new EventEmitter<any>();
	translateContextDelivery: TranslateContext = TranslateContext.DELIVERY;

	constructor(
		private loaderService: LoaderService,
		private uploadFileService: UploadFileService,
		private messageManagerService: MessageManagerService,
		public dialog: MatDialog
	) {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.attachments.currentValue !== changes.attachments.previousValue) {
			this.attachments = changes.attachments.currentValue;
		}
	}

	downloadAttached(file: DigitalSignAttachmentModel): void {
		this.loaderService.display(true);
		this.uploadFileService.downloadAttachedFile(file.file_manager_id).subscribe(
			response => {
				if (!Utilities.isVoid(response)) {
					try {
						Utilities.downloadFile(response, file.blob_name);
					} catch (error) {
						this.messageManagerService.pushInnerMessage({
							componentType: MessageComponentType.SNACK_BAR,
							type: MessageType.TYPE_ERROR,
							code: CommonMessageCode.FILE_DOWNLOAD_KO
						});
					}
				} else {
					this.messageManagerService.pushInnerMessage({
						componentType: MessageComponentType.SNACK_BAR,
						type: MessageType.TYPE_ERROR,
						code: CommonMessageCode.FILE_DOWNLOAD_KO
					});
				}
				this.loaderService.display(false);
			}, () => {
				this.messageManagerService.pushInnerMessage({
					componentType: MessageComponentType.SNACK_BAR,
					type: MessageType.TYPE_ERROR,
					code: CommonMessageCode.FILE_DOWNLOAD_KO
				});
				this.loaderService.display(false);
			}
		);
	}

	removeAttached(event: any, file: DigitalSignAttachmentModel): void {
		event.preventDefault();
		event.stopPropagation();
		AddAttachedFileUtilitiesModel.confirmDeleteFileDialog(this.dialog, file.blob_name, file.description).subscribe(
			result => {
				if (!Utilities.isVoid(result) && result) {
					this.deleteFile(file);
				}
			});
	}

	private deleteFile(file: any): void {
		this.onRemoveFile.emit(file);
	}
}
